import { render, staticRenderFns } from "./SubmissionHistory.vue?vue&type=template&id=5e138b19&"
import script from "./SubmissionHistory.vue?vue&type=script&lang=js&"
export * from "./SubmissionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports